import { GeneralSettingsModel } from '@geosecma/settings';
import { types } from 'mobx-state-tree';
import { RowModel } from '../rowModel';

export const GeneralSettingsStore = types.compose(RowModel, GeneralSettingsModel).named('GeneralSettingsStore');
